import ls from 'local-storage';
import axios from 'axios';
const API_KEY =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DEV_API_URL
    : process.env.REACT_APP_PROD_API_URL;
const instance = axios.create({
  baseURL: API_KEY
});

function redirectToLogin() {
  ls.remove('skBOToken');
  ls.remove('orgID');
  ls.remove('userDetail');
  ls.remove('prov');
  ls.remove('city');
  ls.remove('booth');
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}

async function reFetchToken(error) {
  const BASE_URL = API_KEY.replace(/\/+$/, '');
  const responseT = await axios.post(
    `${BASE_URL}/auth/reCreate`,
    {},
    {
      headers: {
        Authorization: `Bearer ${ls.get('skBOToken')}`
      }
    }
  );

  if (responseT?.data?.status === 200 && responseT?.data?.token) {
    const newToken = responseT.data.token;

    ls.set('skBOToken', newToken);

    const originalRequest = error.config;

    originalRequest.headers = {
      ...originalRequest.headers,
      Authorization: `Bearer ${newToken}`
    };

    return instance(originalRequest);
  }

  if (
    responseT?.data?.success === false ||
    responseT?.data?.status === 401
  ) {
    redirectToLogin();
  }

  throw error;
}

instance.defaults.timeout = 1000000;
instance.interceptors.request.use((config) => {
  // config.headers = {};
  config.headers = config.headers || {};
  if (ls.get('skBOToken')) {
    config.headers['Authorization'] = 'Bearer ' + ls.get('skBOToken');
  } else {
    // config.headers['Authorization'] =
      // 'Bearer QXRvelhmeW54bHUvOWRJLzJ5S04zMTNiV3kzVUNoa00vRVcxNENXQk0yOWNBMlM3Wlk4QlNNU1lhb243VVZqK0tsVmlrYUx0amtDNU9pSzZ2cUh3QU1PSTB0eGtHblFhaTA4YWcvRDl0cnJQV0FaZVNvVWxuSmdXVVQ4a04vTlg';
  }

  return config;
});
/* 
instance.interceptors.response.use(
  async function (response) {
    if (
      response.data.status === 401 ||
      response.status !== 200 ||
      typeof response === 'undefined'
    ) {
      // console.log(response)
      const ress = await reFetchToken(response);
      return ress;
    } else {
      return response;
    }
  },
  async function (error) {
    console.log(error.status);
    const originalRequest = error.config;
    if ( ( error.response.status === 401 ||  error.response.status === 403 ) && !originalRequest._retry) {
      const ress = await reFetchToken(error);
      return ress;
    } else if (error.response.status === 500) {
      console.log(error.response.data.message);
    //   ls.set("errorMessage", error.response.data.message)
    }
  }
); 
*/
instance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      (error.response.status === 401 ||
       error.response.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        return await reFetchToken(error);
      } catch (err) {
        redirectToLogin();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);
export default instance;
